import { ArrowBack } from "@mui/icons-material";
import { styled, Tooltip } from "@mui/material";

export const StyledBackArrowHeader = {
    Container: styled(Tooltip)({
        display: "flex",
        borderRadius: 5,
        cursor: "pointer",
        marginLeft: 10,
    }),
    BackArrow: styled(ArrowBack)({
        width: 40,
        height: 40,
    }),
};